import { getPreviousStep } from "@/apps/merchant3/state-manager/previousStep";
import { getNextStep } from "@/apps/merchant3/state-manager/nextStep";
export { getPreviousStep, getNextStep };
